import { Text, type TextProps } from '@mantine/core'

import { type CoreProduct } from '@flecto/types'

export type TextProductQuantityProps = TextProps & {
  product?: CoreProduct
  withX?: boolean | 'before' | 'after'
}

export function TextProductQuantity({
  product,
  withX = false,
  ...props
}: TextProductQuantityProps) {
  if (!product) {
    return null
  }

return (
  <Text {...props}>
    {withX === 'before' && 'x'}
    {product?.quantity}
    {withX === 'after' && 'x'}
  </Text>
)
}
